module.exports = __webpack_public_path__ + "img/206.2ee1ee34.jpg";